import { useState } from 'preact/compat';

export function useDialog(initiallyShown = false): DialogState {
    const [shown, setShown] = useState(initiallyShown);
    const show = () => setShown(true);
    const hide = () => setShown(false);

    return [shown, show, hide];
}

type DialogState = [
    boolean,
    () => void,
    () => void,
];
